import { Button, Icon } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';
import deleteSvg from 'app/assets/images/delete_icon.svg';  
import deleteHighlighted from 'app/assets/images/deleteHighlighted.svg';
import VoidIcon from '@mui/icons-material/RemoveCircleOutline';
import { Delete, Void, EndDate, StartDate } from 'app/models/Placement/PlacementMods';
import { WhiteTooltip } from '@AMIEWEB/Common/Tooltips/WhiteTooltip';
import { selectedModValue } from '../../../ModificationsUtils';

const otherOptionStyle = makeStyles<{ isDelete: boolean; isVoid: boolean }>()((theme, { isDelete, isVoid }) => ({
  labelStyle: {
    textAlign: 'left',
    fontFamily: 'Roboto',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#333333',
  },
  declinedBtn: {
    color: isDelete ? '#CC0000' : '#555555',
    fontWeight: 'bold',
    fontSize: '12px',
    '&:hover': {
      color: '#CC0000',
      backgroundColor: 'transparent',
    },
  },
  voidBtn: {
    color: isVoid ? '#0F6FB9' : '#555555',
    fontWeight: 'bold',
    fontSize: '12px',
    '&:hover': {
      color: '#0F6FB9',
      backgroundColor: 'transparent',
    },
    '& .MuiInputBase-root.Mui-disabled': {
      pointerEvents: 'auto',
    },
  },
  alignBtn: {
    display: 'flex',
    alignItems: 'flex-start',
    flexDirection: 'column',
  },
  statusMargin: {
    marginTop: '12px',
  },
}));

export const DeleteIcon = (
  <Icon>
    <img src={deleteSvg} style={{ marginBottom: '22px', marginTop: '-2px' }} />
  </Icon>
);

export const DeleteHighlighted = (
  <Icon>
    <img src={deleteHighlighted} style={{ marginBottom: '22px', marginTop: '-2px' }} />
  </Icon>
);

export const OtherOption = dialogProps => {
  const { currentModDetails, selectedButton, setSelectedButtons, modsDialogDetails } = dialogProps;
  const { t } = useTranslation();
  const [currentSelected, setCurrentSelected] = useState('');
  const { classes } = otherOptionStyle({
    isDelete: selectedButton?.isDelete,
    isVoid: selectedButton?.isVoid,
  });
  const [hover, setHover] = useState(false);
  const [showVoidButton, setShowVoidButton] = useState(false);
  const getVoidStatusButton = () => {
    if (currentModDetails?.enableVoidOption === false || currentModDetails?.enableVoidOption) {
      setShowVoidButton(true);
    } else {
      setShowVoidButton(false);
    }
  };
  const getTooltTip = () => {
    return selectedModValue(modsDialogDetails) === EndDate || selectedModValue(modsDialogDetails) === StartDate
      ? t('placement.placementMods.voidDisabledForDates')
      : t('placement.placementMods.voidDisabledCommon');
  };
  useEffect(() => {
    getVoidStatusButton();
  }, [currentModDetails]);

  return (
    <div className={classes.statusMargin}>
      <label className={classes.labelStyle}>{t('placement.placementMods.option') + ':'}</label>
      {!showVoidButton && (
        <div className={classes.alignBtn}>
          <Button
            className={classes.declinedBtn}
            variant="text"
            startIcon={selectedButton?.isDelete || hover ? DeleteHighlighted : DeleteIcon}
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => {
              setCurrentSelected(Delete);
              setSelectedButtons({
                ...selectedButton,
                isDelete: !selectedButton?.isDelete,
                isVoid: false,
              });
            }}
          >
            {t('placement.placementMods.delete')}
          </Button>
        </div>
      )}
      {showVoidButton && (
        <div className={classes.alignBtn}>
          <>
            <WhiteTooltip
              title={currentModDetails?.enableVoidOption === false ? getTooltTip() : ''}
              PopperProps={{
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -15],
                    },
                  },
                ],
              }}
            >
              <div>
                <Button
                  className={classes.voidBtn}
                  variant="text"
                  startIcon={<VoidIcon />}
                  disabled={currentModDetails?.enableVoidOption === false}
                  onClick={() => {
                    setCurrentSelected(Void);
                    setSelectedButtons({
                      ...selectedButton,
                      isVoid: !selectedButton?.isVoid,
                      isDelete: false,
                    });
                  }}
                >
                  {t('placement.placementMods.void')}
                </Button>
              </div>
            </WhiteTooltip>
          </>
        </div>
      )}
    </div>
  );
};
